module.exports = __webpack_public_path__ + "img/twit.ab3686ed.png";